<div class="column-content-container">
  <div class="text-center fw-bold mt-5" *ngIf="loadingMessage">
  {{ loadingMessage }}
  </div>
  <div class="mt-3 text-center">
    <a routerLink="/">Find Something!</a>
  </div>
</div>
